export enum LocalStorageKey {
  JWT_TOKEN = 'JWT_TOKEN',
  DEFAULT_COURSE_ID = 'DEFAULT_COURSE_ID',
}
